<script setup>
import BaseTooltip from "../BaseTooltip.vue";
import SvgIcon from "../SvgIcon.vue";

defineOptions({ inheritAttrs: false });

defineProps({
  icon: { type: String, required: true },
  tooltip: { type: String, default: undefined },
  disabled: { type: Boolean, default: false },
});
</script>

<template>
  <BaseTooltip :text="tooltip">
    <button type="button" :disabled class="row-actions-button" v-bind="$attrs">
      <SvgIcon :name="icon" width="14" height="14" />
    </button>
  </BaseTooltip>
</template>
